import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import React from "react";
import { useNavigate } from "react-router-dom";
import { rootColors } from "../../utilities/Colors/Colors";

const SetupPassword = () => {
  const naviagte = useNavigate();
  const handleSubmit = () => {
    setTimeout(() => {
      naviagte("/recoveraccount/resetopt");
    }, 1000);
  };
  return (
    <Stack m={"8rem 0"}>
      {/* <Seo
        title={"SetupPassword | Won-Call AI"}
        description={"Seo description"}
        type={"website"}
      /> */}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            sx={{
              m: 1,
              background: rootColors?.primary,
              fontWeight: "500",
              color: "white",
            }}
          >
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Set-up Password
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="New Password"
              name="email"
              autoComplete="email"
              autoFocus
              // error={!!errors.email}
              // helperText={errors.email}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Confirm Password"
              type="password"
              id="password"
              autoComplete="current-password"
              // error={!!errors.password}
              // helperText={errors.password}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: rootColors?.primary,
                color: "white",
                "&:hover": {
                  backgroundColor: rootColors?.primary,
                },

                fontWeight: "500",
              }}
            >
              Confirm
            </Button>
            <Grid container>
              <Grid item xs={12}>
                <Link href="contact" variant="body2" color={"#fff"}>
                  Need Help? Contact us
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </Stack>
  );
};

export default SetupPassword;
